import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import PageActions from 'store/redux/page'

const PageData = ({ title = '', metas = {} }) => Page => {
    const mapDispatchToProps = dispatch => ({
        setDataPage: headData => dispatch(PageActions.setHeadData(headData))
    })

    class PageWrapper extends PureComponent {
        componentWillMount() {
            this.props.setDataPage({ title, metas })
        }

        render() {
            return <Page {...this.props} />
        }
    }

    return connect(
        null,
        mapDispatchToProps
    )(PageWrapper)
}

export default PageData



// WEBPACK FOOTER //
// src/decorators/PageData.js